import {
    capitalizeFirstLetter,
    checkUndefined,
    cleanTextToNumbers,
    clearText,
    isDebug,
    randomNumber
} from 'react-lf-tools'
import {getLocal, removeLocal, setLocal} from '../hooks/useStorage/useStorage.jsx'
import {address as textsAddress, general as textsGeneral} from '../translate/Translate.jsx'
import moment from 'moment'
import {getCoordinatesGoogleMaps, putAddress} from '../services/Apis.jsx'
import {getDistance} from 'geolib'

import ReactPixel from 'react-facebook-pixel'
import ReactGA from 'react-ga4'

import * as Sentry from '@sentry/react'

const smoothScrolling = (id, time, top = 50, belowTheHeader = false) => {
    try {
        id = clearText(id)
        const target = document.getElementById(id)
        const elem = document.scrollingElement || document.documentElement
        const style = 'scrollTop'
        const unit = ''
        const from = window.scrollY
        const prop = true
        const to = ((target.offsetTop) - (((belowTheHeader) && (target.offsetTop < window.scrollY)) ? (top + 70) : (top)))
        const distance = Math.abs(to - from)
        switch (true) {
            case distance < 250:
                time = 350
                break
            case distance < 500:
                time = 300
                break
            case distance < 750:
                time = 250
                break
            case distance < 1000:
                time = 200
                break
            default:
                time = 50
        }
        if (!elem) return
        let start = new Date().getTime(),
            timer = setInterval(function () {
                let step = Math.min(1, (new Date().getTime() - start) / time)
                if (prop) {
                    elem[style] = (from + step * (to - from)) + unit
                } else {
                    elem.style[style] = (from + step * (to - from)) + unit
                }
                if (step === 1) {
                    clearInterval(timer)
                }
            }, 25);
        if (prop) {
            elem[style] = from + unit
        } else {
            elem.style[style] = from + unit
        }
    } catch (e) {

    }
}

const findListProductByName = (item) => {
    try {
        const array = []
        const menu = getLocal('menuItems', [])
        const listMenu = menu.filter((m) => (m.category !== 'Destaques'))
        for (const lm in listMenu) {
            const products = listMenu[lm].products
            for (const p in products) {
                if (products[p].product.toLowerCase().includes(item.toLowerCase()) && products[p].visibility.includes('DELIVERY')) {
                    array.push(products[p])
                }
            }
        }
        return array
    } catch (e) {
        console.error(e.message)
    }
    return []
}

const findProductBySku = (sku) => {
    try {
        // const data = getLocal('data')
        // const menu = data.menu
        const menu = getLocal('menuItems', [])
        const listMenu = menu.filter((m) => (m.category !== 'Destaques'))
        for (const lm in listMenu) {
            const products = listMenu[lm].products
            for (const p in products) {
                if (products[p].sku === sku) {
                    return products[p]
                }
            }
        }
    } catch (e) {
        console.error(e.message)
    }
    return null
}

const findProductByNameOrSku = (item) => {
    try {
        const menu = getLocal('menuItems', [])
        const listMenu = menu.filter((m) => (m.category !== 'Destaques'))
        for (const lm in listMenu) {
            const products = listMenu[lm].products
            for (const p in products) {
                const query = (`${products[p].product} ${products[p].sku}`).toLowerCase()
                if (query.includes(item.toLowerCase())) {
                    return products[p]
                }
            }
        }
    } catch (e) {
        console.error(e.message)
    }
    return null
}

const findVariationByName = (variations, item) => {
    try {
        for (const v in variations) {
            const options = variations[v].options
            for (const o in options) {
                if (options[o].option.toLowerCase().includes(item.toLowerCase())) {
                    return options[o]
                }
            }
        }
    } catch (e) {
        console.error(e.message)
    }
    return null
}

const checkServiceArea = (address) => {
    try {
        const serviceArea = getLocal('serviceArea')
        for (const sa in serviceArea) {
            let {name, UF, districts} = serviceArea[sa]
            if ((UF.toLowerCase() === address.uf.toLowerCase()) && (name.toLowerCase() === address.city.toLowerCase())) {
                districts = checkUndefined(districts, [])
                for (const d in districts) {
                    let {name, deliveryFee, id_loja, restrictions} = districts[d]
                    if (clearText(name) === clearText(address.neighborhood)) {
                        restrictions = checkUndefined(restrictions, [])
                        if (!restrictions.length) {
                            return {attendance: true, deliveryFee: deliveryFee, id_loja: id_loja, message: ''}
                        }
                        const restriction = restrictions.filter((r) => (r.postalCode === address.zipCode))
                        if (!!restriction.length) {
                            const {status, obs} = restriction[0]
                            if (status !== 'blocked') {
                                return {attendance: true, deliveryFee: deliveryFee, id_loja: id_loja, message: obs}
                            } else {
                                return {attendance: false, message: textsAddress.weDoNotServeYourRegion}
                            }
                        } else {
                            return {attendance: true, deliveryFee: deliveryFee, id_loja: id_loja, message: ''}
                        }
                    }
                }
            }
        }
        return {attendance: false, message: textsAddress.weDoNotServeYourRegion}
    } catch (e) {
        console.error(e.message)
    }
    return {attendance: false, message: textsAddress.weDoNotServeYourRegion}
}

const checkSalesModality = () => {
    const scheduled = getLocal('scheduled', false)
    const scheduledday = getLocal('scheduledday', false)
    const deliveryMode = getLocal('deliveryMode')
    const openDelivery = getLocal('openDelivery', false)
    const openTakeWay = getLocal('openTakeWay', false)
    if (!scheduledday && !scheduled && deliveryMode === 'delivery' && !openDelivery) {
        removeLocal('deliveryMode')
        removeLocal('address')
        return textsGeneral.closedDelivery
    }
    if (!scheduledday && !scheduled && deliveryMode === 'takeaway' && !openTakeWay) {
        removeLocal('takeawayOptions')
        removeLocal('deliveryMode')
        return textsGeneral.closedTakeaway
    }
    return ''
}

const newOrderId = () => setLocal('orderId', new Date().getTime().toString())

const tokenizeCard = (data, orderId) => {
    const token = JSON.stringify({
        cartao: data.number.replaceAll(' ', ''),
        nome: data.name,
        mes: data.month,
        ano: data.year,
        cvv: String(parseInt(data.cvc.split('').reverse().join('')) + parseInt(orderId.slice(-2)))
    })
    return btoa(token)
}

const log = (message, type = 'log') => {
    try {
        if (isDebug('5173')) {
            if (type === 'error')
                console.error(message)
            else if (type === 'table')
                console.table(message)
            else
                console.log(message)
        } else {
            //alert(message)
        }
    } catch (e) {

    }
}

const listOpeningHours = (weeksStore, routes = false) => {
    const weekDays = ['1:2:Segunda', '2:3:Terça', '3:4:Quarta', '4:5:Quinta', '5:6:Sexta', '6:7:Sábado', '0:1:Domingo', '-1:8:Feriado']
    const list = []
    weekDays.forEach(day => {
        const d = parseInt(day.split(':')[0])
        const dayNumber = parseInt(day.split(':')[1])
        const dayName = day.split(':')[2]
        const a = []
        for (let i = 0; i < weeksStore.length; i++) {
            const wds = weeksStore[i]
            if (wds.day.includes(dayNumber)) {
                if (routes) {
                    const route = moment(wds.time, 'HH:mm:ss').format('HH:mm')
                    a.push(route)
                } else {
                    const openTime = moment(wds.openTime, 'HH:mm:ss').format('HH:mm')
                    const closeTime = moment(wds.closeTime, 'HH:mm:ss').format('HH:mm')
                    a.push(openTime + ' às ' + closeTime)
                }
            } else {
                a.push('')
            }
        }
        list.push({day: dayName, times: routes ? a.join(' , ') : a.join(' '), currentDay: (d === moment().day())})
    })
    return list
}

const distance = async ({street, number = '1', neighborhood, city, zipCode, uf}) => {
    try {
        const address = `${street}, ${number} - ${neighborhood}, ${city} - ${uf}, ${zipCode}`
        const {status, lat, lng} = await getCoordinatesGoogleMaps(address)
        if (status === 'OK') {
            let radiusDistance = calculateRadius(lat, lng)
            return {latitude: lat, longitude: lng, radiusDistance: radiusDistance}
        } else {
            return {latitude: 0, longitude: 0, radiusDistance: -1}
        }
    } catch (e) {
        log(e.message, 'error')
    }
}

const calculateRadius = (lat = 0, lng = 0) => {
    const latitude = getLocal('latitude')
    const longitude = getLocal('longitude')
    let a = {latitude: latitude, longitude: longitude}
    let b = {latitude: lat, longitude: lng}
    return getDistance(a, b)
}

const checkServiceRadius = async (address, register = false) => {
    const radiusList = getLocal('radius', [])
    let radiusMax = getLocal('radiusmax', 0)

    if (!radiusList.length && !radiusMax) {
        return {isServiceRadius: false}
    }

    const maxDistance = Math.max(...radiusList.map(item => item.distance))

    radiusMax = radiusMax || maxDistance

    let addressRadius, latitude, longitude

    const needsGeolocation = register || (!address?.latitude && !address?.longitude && !!address?.number)

    if (needsGeolocation) {
        const {radiusDistance, latitude: lat, longitude: lng} = await distance(address)
        addressRadius = radiusDistance
        latitude = lat
        longitude = lng
    } else {
        addressRadius = calculateRadius(address?.latitude, address?.longitude)
        latitude = address?.latitude
        longitude = address?.longitude
    }

    if (addressRadius > radiusMax) {
        return {
            isServiceRadius: false,
            exceededRadiusLimit: true,
            radiusDeliveryFee: 0,
            latitude,
            longitude,
            radius: addressRadius,
        }
    }

    if (!radiusList.length) {
        return {isServiceRadius: false}
    }

    const matchingRadius = radiusList.find(r => addressRadius <= r.distance)
        || radiusList.reduce((max, r) => (r.distance > max.distance ? r : max))

    return {
        isServiceRadius: true,
        exceededRadiusLimit: false,
        radiusDeliveryFee: matchingRadius.price,
        latitude,
        longitude,
        radius: addressRadius,
    }
}

const checkCityServiceArea = city => {
    const serviceArea = getLocal('serviceArea')
    return serviceArea.some(sa => sa.name.toLowerCase() === city.toLowerCase())
}

const editRegisterAddress = (address) => {
    try {
        const myAddress = getLocal('myAddress', [])
        const index = myAddress.findIndex(m => (m.id === address.id))
        myAddress[index] = address
        setLocal('myAddress', myAddress)
    } catch (e) {
        console.error(e.message)
    }
    updateAddress()
}

const updateAddress = async () => {
    try {
        const profile = getLocal('profile', null)
        if (!!profile?.loggedIn) {
            const myAddress = getLocal('myAddress', [])
            const enderecos = []
            myAddress.forEach(m => {
                enderecos.push({
                    bairro: m.neighborhood,
                    cep: m.zipCode,
                    cidade: m.city,
                    complemento: m.addressComplement,
                    numero: m.number,
                    rua: m.street,
                    uf: m.uf,
                    latitude: !!m?.latitude ? m?.latitude : '',
                    longitude: !!m?.longitude ? m?.longitude : ''
                })
            })
            const data = {
                key: profile.key,
                enderecos: enderecos
            }
            await putAddress(data)
        }
    } catch (e) {
        console.error(e.message)
    }
}

const linkMenu = () => {
    console.table({
        url: `${import.meta.env.VITE_GET_MENU}?authkey=${import.meta.env.VITE_AUTHKEY}&id=${import.meta.env.VITE_ID_STORE}&index=${import.meta.env.VITE_INDEX_STORE}`,
        authkey: import.meta.env.VITE_AUTHKEY,
        id: import.meta.env.VITE_ID_STORE,
        index: import.meta.env.VITE_INDEX_STORE,
        versão: import.meta.env.VITE_VERSION_NAME
    })
}

const restoresProfileData = () => {
    try {
        let data = localStorage.getItem(`bitmenu-${import.meta.env.VITE_AUTHKEY}_${import.meta.env.VITE_ID_STORE}_${import.meta.env.VITE_INDEX_STORE}:cliente`)
        if (data !== null) {
            data = JSON.parse(data)
            const profile = {
                name: data.nome,
                phone: cleanTextToNumbers(`${data.ddd}${data.telefone}`),
                cpf: cleanTextToNumbers(data.cpf)
            }
            setLocal('profile', profile)
            const myAddress = []
            data.endereco.map(e => myAddress.push({
                id: randomNumber(10),
                street: e.rua,
                neighborhood: e.bairro,
                city: e.cidade,
                zipCode: e.cep,
                uf: e.uf,
                number: e.numero,
                addressComplement: e.complemento,
                latitude: !!e?.latitude ? e?.latitude : '',
                longitude: !!e?.longitude ? e?.longitude : ''
            }))
            setLocal('myAddress', myAddress)
            localStorage.removeItem(`bitmenu-${import.meta.env.VITE_AUTHKEY}_${import.meta.env.VITE_ID_STORE}_${import.meta.env.VITE_INDEX_STORE}:cliente`)
        }
    } catch (e) {
        console.error(e.message)
    }
}

const roundTime = date => {
    const minutes = date.minutes()
    const remainder = minutes % 30
    if (remainder !== 0) date.add(30 - remainder, 'minutes')
    date.seconds(0)
    date.milliseconds(0)
    return date
}

const listTimes = (data) => {
    const array = []
    data.forEach((w) => {
        const currentTime = moment()
        const openTime = moment(w.openTime, 'HH:mm:ss')
        const closeTime = moment(w.closeTime, 'HH:mm:ss')
        if (closeTime.isBefore(openTime)) closeTime.add(1, 'day')
        const data = getLocal('data', {})
        const deliveryMode = getLocal('deliveryMode')
        const timeMax = moment.duration((deliveryMode === 'delivery') ? data.timeDeliverMax : data.timeTakeAwayMax).asMinutes()
        let time = (currentTime.isBefore(openTime))
            ? openTime.add(timeMax, 'minutes')
            : currentTime.add(timeMax, 'minutes')
        time = roundTime(time)
        const times = []
        while (time <= closeTime) {
            times.push(time.format("HH:mm:ss"))
            time.add(30, 'minutes')
        }
        times.forEach(t => array.push(t))
    })
    return array
}

const linkApp = () => {
    let pathname = window.location.pathname
    let path = pathname.includes('/') ? pathname.substring(0, pathname.lastIndexOf('/')) : ''
    return window.location.origin + path
}

const trackEventPixel = (event, data = {}) => {
    try {
        const store = getStoreIdentifier()
        ReactPixel.track(event, {...data, store: store})
    } catch (e) {
        console.error(e)
    }
}

const trackPageView = () => trackEventPixel('PageView')

const getStoreIdentifier = () => {
    try {
        const host = window.location.hostname
        const path = window.location.pathname.split('/')[1]

        if (host.includes('bitbar.app')) {
            return path || 'main'
        }

        return `${host}${path ? `/${path}` : ''}`
    } catch (e) {
        console.error('Erro no getStoreIdentifier:', e.message)
        return ''
    }
}

const trackEventAnalytics = (eventName, eventParams) => {
    try {
        const store = getStoreIdentifier()
        ReactGA.event(eventName, {
            ...eventParams,
            client_id: store
        })
    } catch (e) {
        console.error(e.message)
    }
}

const formatItemsAnalytics = items => {
    const array_items = []
    try {
        items.forEach(i => array_items.push({
            item_id: i.sku,
            item_name: capitalizeFirstLetter(`${i?.titulo || i?.product}`),
            price: i?.preco || i?.priceProduct,
            quantity: i?.quantidade || i?.amount
        }))
    } catch (e) {
        console.error(e.message)
    }
    return array_items
}

const prices = (prices) => {
    try {
        const array = []
        prices.forEach((p) => {
            const include = array.some(obj => (obj.price === p.price))
            if (!include) array.push(p)
        })
        if (array.length === 1) array[0].description = ''
        return array
    } catch (e) {
        log(e.message, 'error')
    }
    return prices
}

const colors = (document) => {
    const {
        primaryColor,
        secundaryColor,
        bodyColor,
        textBodyColor,
        cardProduct,
        titleColor,
        descriptionColor,
        priceColor,
        buttonColor,
        textButtonColor,
        toolbarColor,
        textToolbarColor
    } = getLocal('colors')
    document.documentElement.style.setProperty('--primary-color', primaryColor)
    document.documentElement.style.setProperty('--secundary-color', secundaryColor)
    document.documentElement.style.setProperty('--body-color', bodyColor)
    document.documentElement.style.setProperty('--text-body-color', textBodyColor)
    document.documentElement.style.setProperty('--card-color', cardProduct)
    document.documentElement.style.setProperty('--title-color', titleColor)
    document.documentElement.style.setProperty('--description-color', descriptionColor)
    document.documentElement.style.setProperty('--price-color', priceColor)
    document.documentElement.style.setProperty('--button-color', buttonColor)
    document.documentElement.style.setProperty('--text-button-color', textButtonColor)
    document.documentElement.style.setProperty('--toolbar-color', toolbarColor)
    document.documentElement.style.setProperty('--text-toolbar-color', textToolbarColor)
}

const fixEncoding = (str) => {
    const decoder = new TextDecoder('utf-8')
    const bytes = new Uint8Array(str.split('').map(c => c.charCodeAt(0)))
    return decoder.decode(bytes)
}

const roundValues = value => parseFloat(value.toFixed(2))

export {
    smoothScrolling,
    findListProductByName,
    findProductBySku,
    findProductByNameOrSku,
    findVariationByName,
    checkServiceArea,
    checkCityServiceArea,
    checkSalesModality,
    newOrderId,
    tokenizeCard,
    log,
    listOpeningHours,
    distance,
    checkServiceRadius,
    editRegisterAddress,
    updateAddress,
    linkMenu,
    restoresProfileData,
    roundTime,
    listTimes,
    linkApp,
    trackEventPixel,
    trackPageView,
    trackEventAnalytics,
    getStoreIdentifier,
    formatItemsAnalytics,
    prices,
    colors,
    fixEncoding,
    roundValues
}
